import { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import InCountry from "../../Components/InCountry/InCountry";
import s from "./InOtherCountries.module.scss";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import CountriesButtons from "../../Components/CountriesButtons/CountriesButtons";
import DiseaseButtons, {
  IDisease,
} from "../../Components/DiseaseButtons/DiseaseButtons";
import CountriesBlueButtons from "../../Components/CountriesBlueButtons/CountriesBlueButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getIamInOtherCountries,
  getOtherCountriesDeportList,
} from "../../redux/InformationSlice";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Seo } from "../../Seo";

const InOtherCountries = () => {
  const dispatch: AppDispatch = useDispatch();

  const inOtherCountriesInfo = useSelector(
    (state: RootState) => state.info.inOtherCountriesInfo,
  );
  const { t } = useTranslation();

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const { width } = useWindowDimensions();

  const diseaseList = useSelector(
    (state: RootState) => state.info.otherCountriesDeportList,
  );

  useEffect(() => {
    dispatch(getIamInOtherCountries());
    dispatch(getOtherCountriesDeportList());
  }, []);

  return (
    <div>
      <Seo
        title="Медобследование до отъезда на работу за границу"
        description="Какие анализы сдать для долгосрочной визы, как провозить лекарства через границу и подготовиться к миграции"
        url="https://www.vputi.org/otherCountries"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}

        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство других стран",
            path: "/",
          }}
        />
        <ContactButtons />
        <CountriesButtons />
        <div className={s.inner}>
          <div className={s.text_1}>
            <div className={s.image}>
              <img className={s.img} src={inOtherCountriesInfo?.image} />
            </div>
            <div className={s.text_1_wrapper}>
              <div className={s.text_title}>
                {inOtherCountriesInfo?.title_1}
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: inOtherCountriesInfo?.body_1 ?? "",
                }}
                className={s.decription}
              />
            </div>
          </div>
          <div className={s.text_2}>
            <div
              className={s.description_2}
              dangerouslySetInnerHTML={{
                __html: inOtherCountriesInfo?.body_2 ?? "",
              }}
            ></div>
          </div>
          <div className={s.text_3}>
            <div className={s.title_3}>{inOtherCountriesInfo?.title_3}</div>
            <div
              className={s.description_3}
              dangerouslySetInnerHTML={{
                __html: inOtherCountriesInfo?.body_3 ?? "",
              }}
            ></div>
            <div className={s.title_3}>{inOtherCountriesInfo?.title_4}</div>
            <div
              className={s.description_3}
              dangerouslySetInnerHTML={{
                __html: inOtherCountriesInfo?.body_4 ?? "",
              }}
            ></div>
          </div>

          <DiseaseButtons
            diseases={diseaseList?.map((it) => ({
              id: it.id,
              button: it.button,
              button_ru: it.button,
              button_kg: it.button_ky,
              button_uz: it.button_uz,
              button_tj: it.button_tg,
            }))}
            country="otherCountries"
          />

          <div className={s.title}>
            {t("Где я могу пройти обследования на родине?")}
          </div>
          <CountriesBlueButtons />
        </div>
        <div className={s.restrictions}>
          <div className={s.restrictions_image}>
            <img src="/images/Limitation.svg" className={s.restrictions_img} />
          </div>
          <div className={s.restrictions_text}>
            <div className={s.restrictions_title}>
              {t(
                "Узнай больше об ограничениях на въезд для мигрантов, живущих с ВИЧ",
              )}
            </div>
            <Link
              to="/otherCountries/restrictions"
              className={s.restrictions_btn}
            >
              {t("В ДРУГИХ СТРАНАХ")}
            </Link>
          </div>
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default InOtherCountries;
